import { render, staticRenderFns } from "./GraphicsText2.vue?vue&type=template&id=bba7b1d8&scoped=true"
import script from "./GraphicsText2.vue?vue&type=script&lang=js"
export * from "./GraphicsText2.vue?vue&type=script&lang=js"
import style0 from "./GraphicsText2.vue?vue&type=style&index=0&id=bba7b1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba7b1d8",
  null
  
)

export default component.exports